import type { SportsApi } from "@/v2/api/metadata/sports";
import type { BackofficeContext } from "@/v2/framework/context/types";
import type { TranslationsTab } from "@/v2/framework/dialog/types";
import { readApiData } from "@/v2/api/response";
import { formatTranslationsForUpdate } from "@/services/helpers";
import { buildSportTranslationFields } from "../../translation-fields";

export function createTranslationsTab(options: {
  ctx: BackofficeContext;
  sportsApi: SportsApi;
}): TranslationsTab {
  const { ctx, sportsApi } = options;

  return {
    kind: "translations",
    id: "translations",
    label: "Translations",
    persistence: "isolated",
    parentSubmitWithUnsavedTranslations: "block",
    fields: buildSportTranslationFields,
    api: {
      get: async ({ values }) => {
        const sport = values as { id: string | number };
        const translations = readApiData(await sportsApi.getTranslations(sport.id));
        const list = Array.isArray(translations) ? translations : [];

        const languages = ctx.read.languages();
        const translationsPerLanguage = (list as Array<{ languageId: string | number }>).reduce(
          (acc, translation) => {
            acc.set(String(translation.languageId), translation);
            return acc;
          },
          new Map(),
        );

        return {
          languages,
          translationsPerLanguage,
        };
      },
      save: async (model, saveCtx) => {
        const entityId = (saveCtx.values as { id: string | number }).id;
        await sportsApi.update(entityId, {
          translations: formatTranslationsForUpdate(
            model as Parameters<typeof formatTranslationsForUpdate>[0],
          ),
        });
      },
    },
  };
}
